<div class="compare-dropdown flex items-center">
  <span class="mr-1 text-sm">Compare to</span>
  <ng-select
    id="compare-snapshot-dropdown"
    class="compare-dropdown w-60 text-sm"
    placeholder="Select a budget snapshot"
    bindValue="value"
    appendTo="body"
    [clearable]="true"
    [searchable]="false"
    [loading]="snapshotLoading"
    [formControl]="snapshotFormControl"
    [items]="snapshotList"
    [groupBy]="groupByFn"
  >
    <ng-template let-item="item" let-index="index" ng-option-tmp>
      <div>
        <div class="flex justify-between">
          <p class="w-40 overflow-hidden text-ellipsis" [auxTooltip]="item.label">
            {{ item.label }}
          </p>
          @if (item.value) {
            <div class="flex items-center">
              @if (snapshotShowEdit && item.snapshot_type === BUDGET_SNAPSHOT_USER_CREATED) {
                <aux-icon
                  name="Pencil"
                  class="mr-1 text-aux-blue"
                  (click)="editSnapshot($event, item)"
                />
              }

              @if (snapshotShowDelete) {
                <aux-icon
                  name="Trash"
                  class="text-aux-red-dark"
                  (click)="deleteSnapshot($event, item)"
                />
              }
            </div>
          }
        </div>
        <p class="text-aux-gray-darkest">{{ item.create_date | date: 'YYYY-MM-dd' }}</p>
      </div>
    </ng-template>
  </ng-select>
</div>
